module.exports = __webpack_public_path__ + "static/media/26UNRWA22.a988b944.jpg";